module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_eye_hide-d448944b8c0cdb42b4ab608c17eb20da.svg";